import type { Person } from '../../eventsApi/persons/person'
import type { Account } from '../accounts/account'
import type { Category } from '../categories/category'
import type { EntryTypeEnum } from '../entries/entry.enum'

export class Classification {
    classificationId: string
    companyId: string
    accountId: string
    match: string
    categoryId: string
    createdAt: Date
    updatedAt?: Date
    status: number
    personId?: string
    person: Person
    account?: Account
    category?: Category
    creditDebit: EntryTypeEnum
    accrualMonth?: number
    accrualYear?: number
    accrualType?: 'absolute' | 'relative'
}
